module.exports = __webpack_public_path__ + "static/img/zhongjiannan.6b0a0e1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongjiannan.gif
// module id = OaQd
// module chunks = 3